import(/* webpackMode: "eager", webpackExports: ["RegistroForm"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/app/registro/registro-form.tsx");
